import type { TwoFactorStats } from '~/store/userData/repository/userData.repository';

export const isTwoFaActive = (stats: TwoFactorStats): boolean => stats.email || stats.google;
